export default __webpack_public_path__ + "static/section_8_details_2-4c8d360e469708c3d2608ff1e39b3d9e.png";